import React from 'react'
import AddCircle from '@mui/icons-material/AddCircle'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const CrewShifts = ({
  setOpenNewShift,
  setOpenAddExistingShift,
  hasShiftsWithoutDuty,
}) => {
  return (
    <>
      <Grid item xs={12} lg={4}>
        <Typography fontWeight={600}>Crew Shifts</Typography>
      </Grid>
      <Grid item xs={12} lg={8}>
        <Stack
          direction={{ sx: 'column', lg: 'row' }}
          spacing={1}
          justifyContent="flex-end"
        >
          {hasShiftsWithoutDuty && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddCircle />}
              onClick={() => setOpenAddExistingShift(true)}
            >
              Add Unallocated Shift
            </Button>
          )}
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddCircle />}
            onClick={() => setOpenNewShift(true)}
          >
            New Shift
          </Button>
        </Stack>
      </Grid>
    </>
  )
}

export default CrewShifts
